import axios from "axios";

const getEffectiveContracts = async function () {
  try {
    const res = await axios.get(`/effective_contracts`);
    return [res.data, null]
  } catch (err) {
    return [null, err.response.data]
  }
}


export {
  getEffectiveContracts,
}